export default __webpack_public_path__ + "static/media/hero-banner-2.22847853.jpg";